import React from 'react';

import AdminPageHeader from './AdminPageHeader';
import useAbdmEnabled from '../../hooks/useAbdmEnabled';

export const ABDM_NOT_ENABLED_MESSAGE = 'ABDM is not enabled for this organisation.';

/**
 * Wraps a whole ABHA/HIP/HIU page. Renders nothing until the org's ABDM mode is known (no flash, no
 * request behind it), the plain notice when ABDM is off, and `children` otherwise. A failed mode fetch
 * counts as enabled (see abdmModeStore).
 */
export default function AbdmEnabledGate({ children }) {
  const { ready, enabled } = useAbdmEnabled();
  if (!ready) return null;
  if (!enabled) {
    return (
      <div className="min-h-screen bg-slate-50 dark:bg-slate-900">
        <AdminPageHeader />
        <main className="max-w-xl mx-auto p-6">
          <p role="status" className="text-sm text-slate-700 dark:text-slate-200">{ABDM_NOT_ENABLED_MESSAGE}</p>
        </main>
      </div>
    );
  }
  return children;
}
